const TRANSIENT_HTTP_STATUSES = new Set([502, 503, 504]);

export const TRANSIENT_QUERY_LOG_PATTERNS = [
  'AxiosError: Network Error',
  'AxiosError: Request failed with status code 502',
  'AxiosError: Request failed with status code 503',
  'AxiosError: Request failed with status code 504',
];

export const getQueryErrorStatus = (error: any): number | undefined =>
  error?.status ?? error?.response?.status;

/**
 * Network loss and a temporarily unavailable local/API gateway are expected
 * recoverable states on mobile. They should keep the current screen mounted
 * while React Query retries instead of opening the native development LogBox.
 */
export const isTransientQueryError = (error: any): boolean => {
  if (error?.code === 'ERR_CANCELED') {
    return true;
  }

  const status = getQueryErrorStatus(error);
  if (status !== undefined) {
    return TRANSIENT_HTTP_STATUSES.has(status);
  }

  return error?.isAxiosError === true || error?.code === 'ERR_NETWORK';
};

export const shouldUseQueryErrorBoundary = (error: any): boolean =>
  !isTransientQueryError(error);
